import "./assets/styles/index.scss";
import "./validationRules";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import App from "./App.vue";
import { BootstrapVue } from "bootstrap-vue";
import { GLOBAL_TOAST_OPTIONS } from "./utils/constants";
import { GroupChannelModule } from "@sendbird/chat/groupChannel";
import SendbirdChat from "@sendbird/chat";
import Toast from "vue-toastification";
import VCalendar from "v-calendar";
import Vue from "vue";
import VueCookies from "vue-cookies";
import VueGtag from "vue-gtag";
import VueMoment from "vue-moment";
import VueNumberFormat from "vue-number-format";
import VuePapaParse from "vue-papa-parse";
import VueRouter from "vue-router";
import VueScrollTo from "vue-scrollto";

import axios from "axios";
import { getBaseURL } from "./utils/helper";
import i18n from "./i18n";
import moment from "moment";
import router from "./router";
import store from "./store";
import vSelect from "vue-select";
import vueDebounce from "vue-debounce";
//ch
Vue.use(Toast, GLOBAL_TOAST_OPTIONS);
Vue.component("v-select", vSelect);
Vue.config.productionTip = false;
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(VuePapaParse);
Vue.use(VueMoment, moment);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(VCalendar, { componentPrefix: "vc" });
Vue.use(vueDebounce);
Vue.use(VueNumberFormat, { decimal: ".", thousand: " ", prefix: "$" });
Vue.use(VueScrollTo, {
  container: "body",
  duration: 1000,
  easing: "ease",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
Vue.use(
  VueGtag,
  {
    config: {
      id: "G-0HY7P7TCQJ"
    }
  },
  router
);

Vue.filter("formatDate", function(value) {
  if (!value) return "";
  return moment(value).format("DD. MM. YYYY");
});
Vue.filter("formatDateTime", function(value) {
  if (!value) return "";
  return moment(value).format("DD. MM. YYYY HH:mm");
});

axios.defaults.baseURL = getBaseURL(false);

const sb = SendbirdChat.init({
  appId: "5384744D-003F-462E-898D-AB0D1725C0D4",
  modules: [new GroupChannelModule()]
});

Vue.prototype.$sb = sb;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
